import type { AxiosError } from 'axios';
import { useAxiosInstance } from '@gov-nx/api/axios';
import type { ResponseError } from '@gov-nx/api/errors/errors.types';
import type { OsobyKomunikacniUdajeDto } from '@gov-nx/api/generated/osoby.types';
import { usePoQuery } from '@gov-nx/api/hooks/usePoQuery';
import { robCommunicationQuery } from '@gov-nx/api/queries/communicationQuery';

export interface RobCommunicationQueryProps {
	onSuccess?: (data: OsobyKomunikacniUdajeDto) => void;
	onError?: (error: AxiosError<ResponseError>) => void;
	enabled?: boolean;
	cacheTime?: number;
	retry?: number;
}

export const robCommunicationQueryKey = ['person-communication'];

export const useRobCommunicationQuery = (
	props?: RobCommunicationQueryProps
) => {
	const { axiosInstance } = useAxiosInstance();

	const query = usePoQuery({
		queryKey: robCommunicationQueryKey,
		queryFn: () => robCommunicationQuery(axiosInstance),
		onSuccess: props?.onSuccess,
		onError: props?.onError,
		enabled: props?.enabled,
		cacheTime: props?.cacheTime,
		// An explicit undefined would overwrite the QueryClient's retry default
		...(props?.retry !== undefined && { retry: props.retry }),
	});

	return query;
};
